import React from 'react';
import {BackTop} from 'antd';
import styles from './index.module.less';
import history from "../../libs/history";

// the hook
import {useTranslation} from 'react-i18next';

export default function (props) {
  const {t} = useTranslation();

  return (
    <div className={styles.backTop} style={props.style}>
      <BackTop>
        <div className={[styles.up, styles.action].join(" ")} title={t('回顶部')}/>
      </BackTop>
      {/* <div className={[styles.cart, styles.action].join(" ")} onClick={() => {
        history.push('/cart')
      }} title={t('购物车')}/> */}
      {/*<div className={[styles.custom, styles.action].join(" ")} onClick={()=>{history.push('/custom')}} title="联系客服"/>*/}
    </div>
  )
}
